import { css } from 'lit';

export const propertyGridStyles = css`
  :host {
    display: flex;
    flex-direction: column;
    gap: 0;
    --inspector-pane-bg: transparent;
    --inspector-control-bg: var(--color-sidebar-surface);
    --inspector-pane-separator-color: var(--color-app-border);
    --inspector-label-color: var(--color-app-text);
    background: var(--inspector-pane-bg);
    box-sizing: border-box;
    border-radius: 0;
    padding: 0;
    --mod-picker-focus-indicator-gap: 0px;
    --inspector-label-column-width: clamp(112px, 30%, 140px);
    --inspector-label-action-size: 20px;
    --inspector-label-action-icon-size: 10px;
  }
  section {
    display: flex;
    flex-direction: column;
    gap: 0;
    margin-bottom: 14px;
  }
  section {
    border-bottom: 1px solid var(--inspector-pane-separator-color);
  }
  section:last-of-type {
    border-bottom: none;
  }

  h3 {
    margin: 0 0 7px;
    color: var(--color-app-text);
    font-size: 12px;
    font-weight: 650;
    line-height: 1.25;
  }
  .config-field {
    display: grid;
    grid-template-columns:
      var(--inspector-label-column-width)
      minmax(0, 1fr);
    align-items: center;
    gap: 10px;
    min-width: 0;
    min-height: 34px;
    padding: 4px 0;
    margin: 0;
  }
  .config-field--stacked {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
  }
  .config-field-label-wrap {
    min-width: 0;
    display: flex;
    align-items: center;
    background: transparent;
    cursor: pointer;
  }
  .config-field--stacked .config-field-label-wrap {
    flex: none;
    min-width: 0;
    width: 100%;
  }
  .config-field-control {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 12px;
  }
  .config-field--stacked .config-field-control {
    align-items: stretch;
  }
  .config-field-control > sp-switch {
    padding-inline: var(--spectrum-component-edge-to-text-100);
  }
  .config-field-control > sp-textfield,
  .config-field-control > sp-picker,
  .config-field-control > sb-code-editor {
    width: 100%;
    font-size: 12px;
    --mod-textfield-background-color: var(--inspector-control-bg);
    --spectrum-textfield-background-color: var(--inspector-control-bg);
    --mod-textfield-placeholder-font-size: 12px;
    --mod-textfield-border-width: 0px;
    --mod-textfield-focus-indicator-width: 0px;
    --mod-picker-font-size: 12px;
    --mod-picker-border-width: 0px;
    --mod-picker-focus-indicator-thickness: 0px;
    --mod-picker-background-color-default: var(--inspector-control-bg);
    --mod-picker-background-color-hover: var(--mod-picker-background-color-default);
    --mod-picker-background-color-active: var(
      --mod-picker-background-color-default
    );
    --mod-picker-background-color-key-focus: var(
      --mod-picker-background-color-default
    );
    --mod-picker-background-color-default-open: var(
      --mod-picker-background-color-default
    );
    --mod-picker-background-color-hover-open: var(
      --mod-picker-background-color-default
    );
  }
  .config-field-control > sp-textfield.connection-name-field {
    --mod-textfield-icon-size-valid: 0px;
    --mod-textfield-icon-spacing-inline-start-valid: 0px;
    --mod-textfield-icon-spacing-inline-end-valid: 0px;
    --mod-textfield-icon-spacing-block-valid: 0px;
    --mod-textfield-icon-color-valid: transparent;
  }
  .config-field-label {
    display: block;
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
    font-size: 12px;
    color: var(--inspector-label-color);
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.25;
  }
  .config-field-label-wrap > overlay-trigger {
    display: flex;
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
  }
  .label-fullscreen-button {
    flex: 0 0 auto;
    --mod-actionbutton-icon-size: var(--inspector-label-action-icon-size);
    --mod-actionbutton-gap: 0px;
    min-width: var(--inspector-label-action-size);
    height: var(--inspector-label-action-size);
    padding: 0;
    margin-inline-start: auto;
  }
  .config-field-error {
    color: var(--spectrum-negative-color-900, #c9252d);
    font-size: 11px;
    line-height: 1.35;
    margin: 0;
    padding: 4px 0 8px;
  }
`;
